import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TbaRegistrationDTO } from 'src/app/models/TbaRegistrationDTO';
import { ApiService } from 'src/app/services/api.service';
import { DashboardBusinessLogicService } from 'src/app/services/dashboard-business-logic.service';
import { EncryptDecryptService } from 'src/app/services/encrypt-decrypt.service';
import { NewAgentApiService } from 'src/app/services/new-agent-api.service';
import { RootScopeService } from 'src/app/services/root-scope.service';
import * as Constants from '../../../models/Constants';
import { ALIGHT_SAVIYNT_CLOUD_LOGIN_URL, TBA_LOGIN_URL } from '../../../models/Constants';
import { LogService } from 'src/app/services/log.service';

@Component({
  selector: 'app-tba-registration',
  templateUrl: './tba-registration.component.html',
  styleUrls: ['./tba-registration.component.scss']
})
export class TbaRegistrationComponent{
  tbaGuiRegisterFormObj = new TbaRegistrationDTO();
  iconConfigEye = {
    iconName: 'eye',
    iconType: 'light',
  };
  iconConfigEyeSlash = {
    iconName: 'eye-slash',
    iconType: 'light',
  };
  hidePwdIcon = true;
  inputDataType: string = atob(Constants.DATA_TYPE.pinputType);
  disableConnectButton: boolean = false;
  accountNotBlocked: boolean = true;
  tbaRegisterForm: any;
  tbaguiHelpUrlObj: any;
  tbaguiHelpUrl: any;
  fileName: string = 'TBA_Registration_Component';
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public rootScope: RootScopeService,
    public dashboardService: DashboardBusinessLogicService,
    private encrytDecryptService: EncryptDecryptService,
    private http: HttpClient,
    private logService: LogService
  ) {
    this.tbaRegisterForm = new FormGroup({
      racfId: new FormControl('', Validators.required,),
      racfPassword: new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(8)]),
    });

  }


  /**Below method handle the toggle of UI password eye/eye-slash on click of the icon */

  togglePwdIcon() {
    this.hidePwdIcon = !this.hidePwdIcon;
    this.hidePwdIcon
      ? (this.inputDataType = atob(Constants.DATA_TYPE.pinputType))
      : (this.inputDataType = Constants.DATA_TYPE.text);
  }

  /**Below method onLoadTbaGuiReg() set the value of TBAGUIRegistrationnAuthorized on refresh */

  onLoadTbaGuiReg() {
    let isPresent = localStorage.getItem('TBAGUIRegistrationnAuthorized');
    let isConnected = localStorage.getItem('isConnected');
    if (isPresent && isConnected) {
      this.rootScope.TBAGUIRegistrationnAuthorized = true;
      //  this.rootScope.TBAGUIConnected=true;
      // this.rootScope.tbaIndicatorClass.next(Constants.TBA_INDICATOR_COLOR.GREEN);
      /* istanbul ignore next */
      this.dashboardService.startTbaConnectivityInterval();
    }
  }

  /**Below method handle the Submit button click event of User Registration Form */

  onSubmit() {
    // console.log('Method onSubmit called ', this.tbaRegisterForm.invalid);
    if (!this.tbaRegisterForm.invalid) {
      this.tbaGuiRegistration();
    }
  }

  /**Below method is used to Close the Success Alert message on click of cross icon  */
  closeSuccess() {
    this.rootScope.TBAGUIRegistrationnAuthorized = false;
  }

  /* Below goToAlightCloud() method open the Alight Cloud application*/
  goToAlightCloud() {
    this.rootScope.openNewTab(ALIGHT_SAVIYNT_CLOUD_LOGIN_URL);
  }

  launchTBAGUIApp() {
    this.rootScope.tbawindow.set(this.rootScope.sessionId, window.open(Constants.TBA_LOGIN_URL, '_self'));
  }

  tbaGuiRegistration() {
    this.logService.debugLogs("TBA Connection initiated", this.fileName);
    this.rootScope.TBAGUIRegistrationUnauthorized = false;
    this.rootScope.TBAGUIRegistrationnAuthorized = false;
    this.rootScope.TBAGUIConnected = false;
    this.rootScope.TBAGUIAccountLockedError = false;
    this.rootScope.TBAGUIRegistrationUnexpectedError = false;
    this.accountNotBlocked = true;
    // console.log('Method tbaGuiRegistration called');
    this.tbaGuiRegisterFormObj.sessionId = localStorage.getItem('userSession');
    this.rootScope.tbaGuiRegisterFormObj = { racfId: this.tbaRegisterForm.value.racfId, racfPassword: this.tbaRegisterForm.value.racfPassword || "", sessionId: this.tbaGuiRegisterFormObj.sessionId };
    this.tbaGuiRegisterFormObj.racfId = this.encrytDecryptService.encrypt(this.tbaRegisterForm.value.racfId);
    this.tbaGuiRegisterFormObj.racfPassword = this.encrytDecryptService.encrypt(this.rootScope.tbaGuiRegisterFormObj.racfPassword);
    // sessionStorage.setItem("tbaGuiRegisterFormObj", JSON.stringify(this.rootScope.tbaGuiRegisterFormObj));

    this.tbaguiHelpUrlObj = this.rootScope.getObjFromConfigObj(Constants.REG_TBAGUI_TROUBLE_LOGIN_URL);
    this.tbaguiHelpUrl = this.tbaguiHelpUrlObj?.['fieldValue'];
    /* istanbul ignore next */
    this.dashboardService.tbaGuiRegistration(this.tbaGuiRegisterFormObj).subscribe({
      next: (data: any) => {

        //  console.log('res', data);
        let obj = JSON.parse(data);
        let finalData = obj?.data;
        if (finalData?.authenticated && finalData?.reasonDescription == Constants.REASON_DESCRIPTION_VALID
          && finalData?.reasonCode == Constants.REASON_CODE_SUCESS) {         
          this.rootScope.TBAGUIRegistrationUnauthorized = false;
          this.rootScope.TBAGUIRegistrationUnexpectedError = false;
          this.rootScope.TBAGUIAccountLockedError = false;
          this.rootScope.TBAGUIRegistrationPassExpire = false;
          this.rootScope.TBAGUIRegistrationnAuthorized = true;
          // this.rootScope.TBAGUIConnected=true;
          localStorage.setItem("TBAGUIRegistrationnAuthorized", 'true');
          localStorage.setItem("isConnected", 'true');
          localStorage.setItem("TBAGUIStatusConnected", 'true');
          this.logService.debugLogs("TBA Connected successfully.", this.fileName);
          this.launchTBAGUIApp();
          this.dashboardService.getTBAGUIWebFrontData();
          setTimeout(() => {
            this.dashboardService.closeTBAWebFrontTab();
          }, Constants.TBA_TimeOut);
         
        }
        else if (!finalData?.authenticated && finalData?.reasonDescription == Constants.REASON_DESCRIPTION_INVALID
          && finalData?.reasonCode == Constants.REASON_CODE_ACC_LOCKED) {        
          this.rootScope.TBAGUIRegistrationnAuthorized = false;
          this.rootScope.TBAGUIConnected = false;
          this.rootScope.TBAGUIRegistrationUnauthorized = false;
          this.rootScope.TBAGUIRegistrationUnexpectedError = false;
          this.rootScope.TBAGUIRegistrationPassExpire = false;
          localStorage.removeItem('TBAGUIRegistrationnAuthorized');
          localStorage.removeItem('isConnected');
          localStorage.removeItem('TBAGUIStatusConnected');
          this.rootScope.TBAGUIAccountLockedError = true;
          this.accountNotBlocked = false;
          this.tbaRegisterForm.reset();
          this.disableConnectButton = true;
          this.tbaRegisterForm.disable();
          this.logService.errorLogs("TBA Registration failed due to account locked or Invalid | Response type - " + JSON.stringify(obj) , this.fileName);
        }

        else if (!finalData?.authenticated && finalData?.reasonDescription == Constants.REASON_DESCRIPTION_EXPIRED
          && finalData?.reasonCode == Constants.REASON_CODE_PASS_EXPIRED) {       
          this.rootScope.TBAGUIRegistrationnAuthorized = false;
          this.rootScope.TBAGUIConnected = false;
          this.rootScope.TBAGUIAccountLockedError = false;
          this.rootScope.TBAGUIRegistrationUnexpectedError = false;
          this.rootScope.TBAGUIRegistrationUnauthorized = false;
          localStorage.removeItem('TBAGUIRegistrationnAuthorized');
          localStorage.removeItem('isConnected');
          localStorage.removeItem('TBAGUIStatusConnected');
          this.rootScope.TBAGUIRegistrationPassExpire = true;
          this.logService.errorLogs("TBA Registration failed due to password expired | Response type - " + JSON.stringify(obj), this.fileName);
        }
        else if (!finalData?.authenticated && finalData?.reasonDescription == Constants.REASON_DESCRIPTION_INVALID
          && finalData?.reasonCode != Constants.REASON_CODE_ACC_LOCKED) {        
          this.rootScope.TBAGUIRegistrationnAuthorized = false;
          this.rootScope.TBAGUIConnected = false;
          this.rootScope.TBAGUIAccountLockedError = false;
          this.rootScope.TBAGUIRegistrationUnexpectedError = false;
          this.rootScope.TBAGUIRegistrationPassExpire = false;
          localStorage.removeItem('TBAGUIRegistrationnAuthorized');
          localStorage.removeItem('isConnected');
          localStorage.removeItem('TBAGUIStatusConnected');
          this.rootScope.TBAGUIRegistrationUnauthorized = true;
          this.logService.errorLogs("TBA Registration failed due to Invalid access | Response type - " + JSON.stringify(obj), this.fileName);
        }
        else {
          this.rootScope.TBAGUIRegistrationUnauthorized = false;
          this.rootScope.TBAGUIRegistrationnAuthorized = false;
          this.rootScope.TBAGUIConnected = false;
          this.rootScope.TBAGUIRegistrationUnauthorized = false;
          this.rootScope.TBAGUIRegistrationPassExpire = false;
          localStorage.removeItem('TBAGUIRegistrationnAuthorized');
          localStorage.removeItem('isConnected');
          localStorage.removeItem('TBAGUIStatusConnected');
          this.rootScope.TBAGUIRegistrationUnexpectedError = true;
          this.logService.errorLogs("TBA Registration failed due to unexpected error | Response type - " + JSON.stringify(obj), this.fileName);
        }
      },
      error: (error: any) => {
        let obj;
        if (typeof error?.error === 'string') {
          obj = JSON.parse(error?.error);
        } else {
          obj = error;
        }
        if (error?.status == 401) {
          this.rootScope.TBAGUIRegistrationnAuthorized = false;
          this.rootScope.TBAGUIConnected = false;
          this.rootScope.TBAGUIRegistrationUnexpectedError = false;
          this.rootScope.TBAGUIAccountLockedError = false;
          this.rootScope.TBAGUIRegistrationPassExpire = false;
          localStorage.removeItem('TBAGUIRegistrationnAuthorized');
          localStorage.removeItem('isConnected');
          localStorage.removeItem('TBAGUIStatusConnected');
          this.rootScope.TBAGUIRegistrationUnauthorized = true;
          this.logService.errorLogs("TBA Registration failed due to unauthorized access | Error type - " + JSON.stringify(obj), this.fileName);
        }
        else {
          this.rootScope.TBAGUIRegistrationUnauthorized = false;
          this.rootScope.TBAGUIRegistrationnAuthorized = false;
          this.rootScope.TBAGUIConnected = false;
          this.rootScope.TBAGUIRegistrationUnauthorized = false;
          this.rootScope.TBAGUIRegistrationPassExpire = false;
          localStorage.removeItem('isConnected');
          localStorage.removeItem('TBAGUIRegistrationnAuthorized');
          localStorage.removeItem('TBAGUIStatusConnected');
          this.rootScope.TBAGUIRegistrationUnexpectedError = true;
          this.logService.errorLogs("TBA Registration failed due to unexpected error | Error type - " + JSON.stringify(obj), this.fileName);
        }
      },
    });
  }

}

